<div class="container">
<div class="fluid-container mt-3">
    <div class="row container-fluid mt-3">
        <!-- Candidate List and Hire Button -->
        <div class="col-lg-3 col-md-3 mb-3 d-flex flex-column">
            <app-list-candidates></app-list-candidates>
         <div class="hire-btn">
            <button class="btn btn-primary mt-3 mt-md-2 w-100" (click)="onHireClicked()">Hire</button>
         </div>
        </div>
        <!-- Chat -->
        <div class="col-12 col-md-9 col-lg-9">
            <app-chat [jobId]="jobId" [employerId]="employerId" [candidateId]="wizardStore.selectedCandidateAccountId" [sender]="'employer'"></app-chat>
        </div>
    </div>
</div>
</div>